import { ActionTree } from 'vuex';
import { TeamsState, Team } from './models';
import { RootState } from '@/store';
import api from './api';
import { Mutations } from './mutations';
import Notify from '@/shared/services/Notify/Notify';
import { ErrorApi } from '@/core/api/ErrorApi';

export enum Actions {
  FETCH_TEAMS = 'FETCH_TEAMS',
}

export const actions: ActionTree<TeamsState, RootState> = {
  async [Actions.FETCH_TEAMS]({ commit }, seasonId?: number) {
    commit(Mutations.GET_TEAMS_REQUEST);
    await api.fetchTeams(seasonId).then(
      (payload: Team[]) => {
        commit(Mutations.GET_TEAMS_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_TEAMS_FAILURE);
        Notify.errorApi(error);
      },
    );
  },
};
